import { z } from "zod";

export const schema = z.object({
    name: z.string().min(1, "forms.general-validation.name_required"),
    form_structure_id: z.string().min(1, "forms.general-validation.form_structure_required"),
    category: z.string().nullable().optional(),
    system_name: z.string().optional(),
    css: z.string().optional(),
    background_color: z.string().optional(),
    width: z.number().optional(),
});

export type FormDesignAddFormData = z.infer<typeof schema>;
